import { RelativeDurationSuffix, RelativeDurationType } from "@inception/ui";
import { DataType, TimeRange } from "../../core";
import { DataQuery } from "../../services/api/types";
import { TimeObj } from "../../services/api/explore";
import VariableModel from "./VariableModel";

export type WidgetType =
  | "timeseries"
  | "donut"
  | "data-grid"
  | "metric-number"
  | "image"
  | "heatmap"
  | "horizontal-bar-chart"
  | "request-count-widget"
  | "filter"
  | string;

export interface Query extends DataQuery {
  expr?: any;
}

export interface CommonWidgetProperties {
  background?: string;
  description?: string;
  transparent?: boolean;
  borderLess?: boolean;
  dataType?: DataType;
  unit?: string;
  downsample?: string;
  viewState?: WidgetViewState;
}

export enum WidgetViewState {
  FULLSCREEN = "fullscreen",
  MINIMIZE = "minimize"
}

export interface CommonWidgetOptions extends Record<string, any> {
  hideActionsOnDragAndSelect?: boolean;
  syncTooltip?: boolean;
  noPadding?: boolean;
}

export interface WidgetMeta {
  edit?: boolean;
  compare?: boolean;
  hideHeader?: boolean;
  resizable: boolean;
  hideActions?: boolean;
  hideTimeRange?: boolean;
}

// Back-end model
export default interface BaseWidgetModel {
  id: string;
  title: string;
  description?: string;
  type: WidgetType;

  datasource: string;
  queries: Query[];
  variables?: VariableModel[];

  maxTimePeriod?: TimeObj;
  timeRange?: TimeRange;
  downsample?: string; //30s, 15s, 900s
  // Used for setting up comparisons in thw widget
  comparisonModel?: WidgetComparisonModel;

  properties?: CommonWidgetProperties;
  options?: CommonWidgetOptions;

  disableAutoRefresh?: boolean;
  autoRefreshInterval?: TimeObj;

  /**
   * Pass in optionally the styles which apply to the widget.
   */
  style?: React.CSSProperties;
  background?: string;
  meta?: WidgetMeta;
}

// Model to be used for dashboard comparison
export enum ComparisonType {
  RELATIVE,
  CUSTOM
}

export type WidgetComparisonModel = {
  comparisonType: ComparisonType;
  // If comparisonType is custom, durationType and durationValue are optional
  durationType?: RelativeDurationType;
  durationValue?: number;

  customStartTime?: Date;
  customEndTime?: Date;
};

export const getDefaultComparisonModel = (): WidgetComparisonModel => ({
  comparisonType: ComparisonType.RELATIVE,
  durationType: RelativeDurationType.DAYS,
  durationValue: 1,
  customStartTime: new Date(Date.now() - 60 * 60 * 1000),
  customEndTime: new Date(Date.now())
});

export { RelativeDurationSuffix, RelativeDurationType };
